const initialState = {
    legalInformation: [],
    contactInformation: {
        contactInfo: [],
        primaryContactInfo: []
    },
    descriptiveInformation: {
        descriptiveInfo: [],
        descriptiveInfoCheckList: []
    },
    stateContactInfo : {
        stateCode: '',
    }
}

const correctYourDataReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case 'UPDATELEGALINFO':
            state = {
                ...state,
                legalInformation: payload
            }
            break;
        case 'UPDATECONTACTINFO':
            state = {
                ...state,
                contactInformation: payload
            }
            break;
        case 'UPDATEDESCRIPTIVEINFO':
            state = {
                ...state,
                descriptiveInformation: payload
            }
            break;
            case 'UPDATESTATECONTACTINFO':
                state = {
                    ...state,
                    stateContactInfo: payload
                }
            break;
        default: return state;

    }
    return state
}

export default correctYourDataReducer
